import isChromatic from 'chromatic/isChromatic';
import cn from 'classnames';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Link } from '#components/atoms/link/Link.tsx';
import { AuditLogList } from '#components/patterns/audit-log/list/AuditLogList.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';
import { Oops } from '#screens/errors/Oops.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import styles from './HostLogs.module.css';

type Props = {
  hostId: string;
  className?: string;
};

const HOST_LOGS_PAGE_SIZE = 5;

export function HostLogs({ hostId, className }: Props) {
  return (
    <div className={className}>
      <h3 className="h4 mb-24">Logs</h3>
      {/* Same dead-Refresh trap as the global boundary in App.tsx: remounting
          re-throws the cached query error, so only a reload moves forward. */}
      <ErrorBoundary fallbackRender={({ error }) => <Oops error={error as unknown} showErrorDetails={false} />}>
        <Suspense fallback={<LoadingSpinner />}>
          <AuditLogList
            className={cn(styles.HostLogs_table, 'mb-12', {
              'chromatic-ignore': isChromatic(),
            })}
            logsQueryArgs={{ targetId: hostId }}
            selectRows={(logs) => logs.slice(0, HOST_LOGS_PAGE_SIZE)}
            EmptyLogsComponent={EmptyLogs}
          />
        </Suspense>
      </ErrorBoundary>
      <Link className="a p-md" to={`/logs/audit?targetId=${hostId}`}>
        View all logs
      </Link>
    </div>
  );
}

function EmptyLogs() {
  return (
    <CenteredLayout>
      <h2 className="h3 mb-16">No results found</h2>
    </CenteredLayout>
  );
}
